import React, { useState, useEffect } from "react";
import { Col, Row, Card, Form, Button } from "@themesberg/react-bootstrap";
import axios from "axios";
import { createAsset, getAsset, updateAsset } from "../../app/api";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import Loadericon from "../../components/Loadericon";
export default () => {
  const { id } = useParams();
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [serial, setSerial] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [vin, setVin] = useState("");
  const [vendor, setVendor] = useState("");
  const [model, setModel] = useState("");
  const [description, setDescritpion] = useState("");
  const [Loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoadingBtn(true);
      const token = localStorage.getItem("token");

      const assetData = {
        title,
        status,

        type,
        serial_no: serial,
        mac_address: macAddress,
        vin,
        model,
        description,
      };

      let response;

      if (id) {
        response = await axios.put(updateAsset(id), assetData, {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        swal({
          text: response.data.message,
          icon: "success",
        }).then(() => {
          history.push(Routes.Assets.path);
        });
      } else {
        response = await axios.post(createAsset(), assetData, {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });

        swal({
          text: response.data.message,
          icon: "success",
        });
       
          setTitle("");
          setStatus("");
          setSerial("");
          setMacAddress("");
          setVin("");
          setModel("");
          setDescritpion("");
          setType("");
          setVendor("");
        
      }

      // console.log(response.data);
    } catch (err) {
      // console.error("error of asset",err.response.data.messages);
      swal({
        text: err.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
     
    }
  };

  const fetchSingleAssets = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getAsset(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setTitle(response.data?.data?.title);
      setStatus(response.data?.data?.status);
      setSerial(response.data?.data?.serial_no);
      setMacAddress(response.data?.data?.mac_address);
      setVin(response.data?.data?.vin);
      setModel(response.data?.data?.model);
      setDescritpion(response.data?.data?.description);
      setType(response.data?.data?.type);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleAssets();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.Assets.path);
  };
  return (
    <>
      {Loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              {/* <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Back</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {id ? "Update Assets" : "Create Assets"}
            </Breadcrumb.Item>
          </Breadcrumb> */}
              <h4 className="mb-0">Assets</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Card.Title>
                    {id ? "Update Asset" : "Create a New Asset"}
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Title">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Status">
                          <Form.Label>Status</Form.Label>
                          <Form.Select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <option value="">Select an Status</option>

                            <option value="available">Available</option>
                            <option value="assigned">Assigned</option>
                            <option value="disposed">Disposed</option>
                            <option value="sold">Sold</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Type">
                          <Form.Label>Type</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Serial #">
                          <Form.Label>Serial #</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Serial #"
                            value={serial}
                            onChange={(e) => setSerial(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="MAC Address">
                          <Form.Label>MAC Address</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter MAC Address"
                            value={macAddress}
                            onChange={(e) => setMacAddress(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="VIN #">
                          <Form.Label>VIN #</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter VIN #"
                            value={vin}
                            onChange={(e) => setVin(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Model">
                          <Form.Label>Model</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Model"
                            value={model}
                            onChange={(e) => setModel(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Model">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Description"
                            value={description}
                            onChange={(e) => setDescritpion(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-between">
                      <Button
                        variant="primary"
                        onClick={handleBackClick}
                        className=" me-2"
                      >
                        <span>Back</span>
                      </Button>
                      {loadingBtn ? (
                        <div className="d-flex justify-content-start">
                          <Loadericon />
                        </div>
                      ) : (
                        <Button
                          variant="primary"
                          type="submit"
                          className=" me-2"
                        >
                          <span>Save</span>
                        </Button>
                      )}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
